<template>

    <div class="page-content">
        <div data-height="130" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="130" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="130" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1>Inicio</h1>
            <a href="#" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
            <span class="bg-highlight color-white">{{ username }}<br>{{ cargo }}</span>
        </div>

        <div class="content">

            <!-- Grilla de apps (estilo pantalla de celular).
                 Mantén presionado un ícono para arrastrarlo al dock de abajo. -->
            <div style="display:flex; flex-wrap:wrap;">
                <a v-for="app in apps" :key="app.id" :href="app.url" :onclick="app.onclick" :data-fid="app.id"
                    class="home-app" draggable="false"
                    style="width:33.33%; text-align:center; padding:14px 6px; text-decoration:none; -webkit-user-select:none; user-select:none; -webkit-user-drag:none;">
                    <span :class="'bg-' + app.tone + '-dark'"
                        style="display:inline-flex; align-items:center; justify-content:center; width:66px; height:66px; border-radius:20px; box-shadow:0 5px 12px rgba(0,0,0,0.15);">
                        <i :data-feather="app.icon" data-feather-line="1.5" data-feather-size="30" data-feather-color="white"></i>
                    </span>
                    <div class="color-theme" style="font-size:12px; font-weight:600; margin-top:8px; line-height:1.2;">{{ app.name }}</div>
                </a>
            </div>

        </div>

    </div>

</template>

<script>

import * as db from "./../../database.js";
import { APP_FUNCTIONS, getUserFunctions } from "./../../appfunctions.js";
import { enableDockDrag } from "./../../dockdrag.js";

export default {

    data() {
        return {
            apps: [],
            username: "",
            cargo: "",
            userimageurl: ""
        };
    },

    methods: {
        // Redibuja los íconos feather y conecta el arrastre de cada app
        refrescar() {
            this.$nextTick(function () {
                if (window.feather) { try { window.feather.replace(); } catch (e) {} }
                var nodos = document.querySelectorAll(".home-app");
                for (var i = 0; i < nodos.length; i++) {
                    var el = nodos[i];
                    if (el._dockDragCleanup) continue; // ya conectado
                    enableDockDrag(el, el.getAttribute("data-fid"), "home");
                }
            });
        }
    },

    created() {
        var user = JSON.parse(localStorage.getItem("user")) || {};
        this.username = user.nombre;
        this.cargo = user.cargo;
        this.userimageurl = "background-image:url(" + db.getServerHTTP() + user.imageurl + ")";

        var cod = user.codusuario || 0;
        var self = this;
        getUserFunctions(cod).then(function (ids) {
            // Si el usuario tiene funciones asignadas, ve solo esas; si no, todas.
            if (ids && ids.length) {
                self.apps = APP_FUNCTIONS.filter(function (f) { return ids.indexOf(f.id) >= 0; });
            } else {
                self.apps = APP_FUNCTIONS.slice();
            }
            self.refrescar();
        });
    },

    mounted() {
        this.refrescar();
    }

}

</script>

<style>
/* Ícono blanco dentro del cuadro de color (estilo app de celular) */
.home-app .feather { stroke: #fff !important; }
</style>
